import DashboardWidgetDataProvider from './DashboardWidgetDataProvider';

Vue.asyncComponent('cms-dashboard-editor', {
    /**
     * Create the reactive state for this dashboard component.
     */
    data() {
        return {
            dataProviderClass: DashboardWidgetDataProvider,
        };
    },
    computed: {
        /**
         * Dashboard owner type.
         */
        dashboardOwnerType() {
            const routeName = this.$route.name || '';
            if (routeName.includes('-user')) {
                return 'user';
            }

            if (routeName.includes('-role')) {
                return 'role';
            }

            const routePath = this.$route.path || '';
            if (routePath.includes('/dashboard-editor/user/')) {
                return 'user';
            }

            if (routePath.includes('/dashboard-editor/role/')) {
                return 'role';
            }

            const routeRecord = [...(this.$route.matched || [])]
                .reverse()
                .find((currentRoute) => currentRoute.meta?.dashboardOwnerType);

            return routeRecord?.meta?.dashboardOwnerType || 'default';
        },
        /**
         * Dashboard editor context.
         */
        dashboardEditorContext() {
            const ownerType = this.dashboardOwnerType;

            return {
                ownerType,
                ownerId: ownerType === 'default'
                    ? 0
                    : (this.$route.params.ownerId || 0),
                dashboardId: this.$route.query.dashboardId || null,
            };
        },
        /**
         * Dashboard editor key.
         */
        dashboardEditorKey() {
            return [
                this.dashboardEditorContext.dashboardId || 'dashboard',
                this.dashboardEditorContext.ownerType,
                this.dashboardEditorContext.ownerId,
            ].join(':');
        },
    },
}, 'cms/dashboard/editor/cms-dashboard-editor-page.html');
